import style from '../style/ManaHeader.module.less';
import { useUserInfo, useDispatch } from '@/hooks/hooks';
import { Divider, Input } from 'antd';
import IconFont from '@/common/IconFont';
import { logout as logoutAction } from '@/store/slices/user';
import Modal from '@/common/modal/Modal';
import { useEffect, useState } from 'react';
import { resetAdminPassword } from '@/service/common/index';
import { passwordReg } from '@/utils';
import layer from '@/utils/layer';
import md5 from 'md5';

// 修改密码弹框
interface ResetPasswordProps {
  visible: boolean;
  onClose: () => void;
}
const ResetPassword: React.FC<ResetPasswordProps> = props => {

  const defaultState = {
    'oldPassword': {
      value: '',
      placeholder: '请输入您的当前密码',
      label: '当前密码'
    },
    'newPassword': {
      value: '',
      label: '新密码',
      placeholder: '8-20位，数字与字母的结合'
    },
    'newPasswordConfirm': {
      value: '',
      label: '确认密码',
      placeholder: '请再次输入新密码'
    }
  };

  const [state, setState] = useState<Record<string, {
    value: string;
    placeholder: string;
    label: string;
  }>>({ ...defaultState });

  useEffect(() => {
    if (!props.visible) {
      setState({ ...defaultState });
    }
  }, [props.visible]);

  const setInputValue = (value: string, key: string) => {
    setState({
      ...state,
      [key]: {
        ...state[key],
        value
      }
    });
  };

  const savePassword = async () => {
    if (!state.oldPassword.value) {
      layer.error('请输入当前密码！');
      return false;
    }
    if (
      state.newPassword.value.length < 8 ||
      !passwordReg.test(state.newPassword.value)
    ) {
      layer.error('请输入8-20位数字、字母组成的密码');
      return false;
    }
    if (state.newPassword.value !== state.newPasswordConfirm.value) {
      layer.error('两次密码输入不一致');
      return false;
    }

    const { data } = await resetAdminPassword(
      md5(state.oldPassword.value), md5(state.newPassword.value)
    );
    if (data) {
      layer.msg('设置成功');
      props.onClose();
    }
  };

  return (
    <Modal
      title="修改密码"
      visible={props.visible}
      onCancel={props.onClose}
      okText="确认"
      onOk={savePassword}
    >
      <div className={style.resetPassword}>
        {
          Object.entries(state).map(([key, { value, placeholder, label }]) => (
            <div key={key}>
              <span>{label}:</span>
              <Input
                maxLength={20}
                placeholder={placeholder}
                value={value}
                onChange={e => setInputValue(e.target.value, key)}
                type="password"
              />
            </div>
          ))
        }
      </div>
    </Modal>
  );
};


const ManaHeader = () => {
  const userState = useUserInfo();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  const logout = () => {
    dispatch(logoutAction());
  };
  return (
    <div className={style.wrapper}>
      <div>
        <img src={require('@/assets/imgs/logo-white.svg').default} alt="" />
        <Divider type="vertical"></Divider>
        <span>后台管理</span>
      </div>
      <div className={style.user}>
        <div>
          <img src={require('@/assets/imgs/user-head.png')} alt="" />
          <span>{userState.name}</span>
        </div>
        <Divider type="vertical"></Divider>
        <div onClick={() => setShowModal(true)}>
          <span>[修改密码]</span>
        </div>
        <Divider type="vertical"></Divider>
        <div onClick={logout}>
          <span>退出</span>
          <IconFont style={{marginTop: '2px'}} type="icon-tuichu1" />
        </div>
      </div>
      <ResetPassword
        visible={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default ManaHeader;